var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceGuest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.3,
    height: 53.211,
    viewBox: "0 0 47.3 53.211",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38756",
    "data-name": "\\uADF8\\uB8F9 38756",
    transform: "translate(-434.867 -1371.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38749",
    "data-name": "\\uADF8\\uB8F9 38749",
    transform: "translate(436.367 1372.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_18429",
    "data-name": "\\uC0AC\\uAC01\\uD615 18429",
    width: 10.683,
    height: 18.077,
    rx: 5.342,
    transform: "translate(0 17.061)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_18430",
    "data-name": "\\uC0AC\\uAC01\\uD615 18430",
    width: 10.683,
    height: 18.077,
    rx: 5.342,
    transform: "translate(33.617 17.061)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19479",
    "data-name": "\\uD328\\uC2A4 19479",
    d: "M501.768,936.6h0a15.884,15.884,0,0,0-15.883-15.883h-1.851A15.884,15.884,0,0,0,468.151,936.6h0",
    transform: "translate(-462.81 -920.719)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19480",
    "data-name": "\\uD328\\uC2A4 19480",
    d: "M508.044,967.478v6.048a8.137,8.137,0,0,1-8.137,8.137H490.55",
    transform: "translate(-468.4 -932.389)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_18432",
    "data-name": "\\uC0AC\\uAC01\\uD615 18432",
    width: 12,
    height: 5,
    rx: 2.5,
    transform: "translate(456 1419.68)",
    fill: "#f09"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceGuest);
export default __webpack_public_path__ + "static/media/icon-service-guest.9177476450f7c834543af2d38d6d28a0.svg";
export { ForwardRef as ReactComponent };